var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-button",class:{ disabled: !_vm.url },attrs:{"href":_vm.url,"disabled":!_vm.url,"target":"_blank"}},[_c('v-icon',[_vm._v("far fa-eye")]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }